
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[[...blog]]",
      function () {
        return require("private-next-pages/blog/[[...blog]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[[...blog]]"])
      });
    }
  